import * as React from 'react';

import {Date} from '../../entity/entity-display-values/date';
import {Description} from '../../entity/entity-display-values/description';
import {Email} from '../../entity/entity-display-values/email';
import {Enum} from '../../entity/entity-display-values/enum';
import {Rating} from '../../entity/entity-display-values/rating';
import {Relationship} from '../../entity/entity-display-values/relationship/relationship';
import {Tokenized} from '../../entity/entity-display-values/relationship/tokenized';
import {String} from '../../entity/entity-display-values/string';
import {Url} from '../../entity/entity-display-values/url';

import {getTitle} from './helpers';

const DISPLAY_COMPONENTS = {
    string: String,
    strings: Tokenized,
    integer: String,
    text: String,
    email: Email,
    phone: String,
    boolean: String,
    enum: Enum,
    number: String,
    currency: String,
    location: String,
    relationship: Relationship,
    'date-time': Date,
    url: Url,
    description: Description,
    rating: Rating,
    default: String,
} as const;

type Props = {
    value: string | number | any[];
    schemaField: any;
    isLeadCard?: boolean;
};

export function RenderedValue(props: Props) {
    const {schemaField} = props;
    const rowType = schemaField.cellType ? schemaField.cellType : schemaField.type;

    const DisplayComponent = Object.keys(DISPLAY_COMPONENTS).includes(rowType)
        ? // @ts-expect-error
          DISPLAY_COMPONENTS[rowType]
        : DISPLAY_COMPONENTS.default;

    return (
        <div data-tip={getTitle(schemaField, props.isLeadCard)} data-place='left'>
            <DisplayComponent
                {...schemaField}
                value={props.value}
                isLeadCard={props.isLeadCard}
                fieldName={schemaField.name}
            />
        </div>
    );
}
